import type { Rating } from '../../../sdk/@types/Revisao';

/** The three CSS keyframe classes (ReviewCard.css) a rating button can play on click.
 *  Each is a one-shot, non-infinite animation with `animation-fill-mode: both`, applied
 *  directly to the `<button>` and cleared again on its own `animationend`. */
export type MovimentoNota = 'rc-move-again' | 'rc-move-hard' | 'rc-move-good';

/** The one table tying a rating to its movement (same "um lugar só" convention as
 *  `fase`, `cardTipoMostrado`, `occlusionModeNoFio`): a plain object lookup, never an
 *  `if`/`switch` on `rating`, so reassigning which movement a rating gets is a one-line
 *  edit here and nowhere else.
 *
 *  `easy` is intentionally absent here — its movement is the full-screen confetti
 *  celebration `confeteNaNota` below marks it for, fired from RatingBar's click handler,
 *  never a CSS class on this button. */
const MOVIMENTOS: Partial<Record<Rating, MovimentoNota>> = {
  again: 'rc-move-again',
  hard: 'rc-move-hard',
  good: 'rc-move-good',
};

export function movimentoDaNota(rating: Rating): MovimentoNota | undefined {
  return MOVIMENTOS[rating];
}

/** Same "um lugar só" convention as `MOVIMENTOS`, for the one rating that celebrates
 *  instead of playing a button-level movement: a plain lookup, so moving the confetti to
 *  a different rating — e.g. to "Errei", the reading the original request suggested and
 *  this table deliberately did not follow (proposal.md, Suposição 1) — is a one-line edit
 *  here, never a `rating === 'easy'` check inside RatingBar's `onClick`. */
const CELEBRACOES: Partial<Record<Rating, true>> = {
  easy: true,
};

export function confeteNaNota(rating: Rating): boolean {
  return CELEBRACOES[rating] === true;
}
